import { isEmpty } from 'lodash/fp';

import { CONTENT_SECTIONS } from '../../../content/sections';
import { ImageObject, Question } from '../../../../../types/__codegen__/sanity/graphql';
import getFormattedQuestionForAccordion from '../../../../../utils/get-formatted-question-for-accordion';
import getImageAttributes from '../../../../../cms/utils/get-image-attributes';
import type { CmsInsuranceTypeContent } from '../../../types';

type MapCommonQuestionsAlternateContent = {
  cmsSectionContent: CmsInsuranceTypeContent['commonQuestions'] | null;
};

const mapCommonQuestionsAlternateContent = ({ cmsSectionContent }: MapCommonQuestionsAlternateContent) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  return {
    image: getImageAttributes({ height: 480, imageObject: cmsSectionContent?.imageObject as ImageObject }),
    isTwoColumn: true,
    items: getFormattedQuestionForAccordion(cmsSectionContent?.questions as Question[]),
    summary: cmsSectionContent?.summaryRaw,
    title: cmsSectionContent?.title,
    type: CONTENT_SECTIONS.COMMON_QUESTIONS_ALTERNATE,
  };
};

export default mapCommonQuestionsAlternateContent;
